export const formatOrderTicketDateTime = (input = new Date()) => {
  const source = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(source.getTime())) {
    return '';
  }

  const pad = (value) => String(value).padStart(2, '0');

  const day = pad(source.getDate());
  const month = pad(source.getMonth() + 1);
  const year = source.getFullYear();
  const hours = pad(source.getHours());
  const minutes = pad(source.getMinutes());

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};
